import { render } from "./TenantManagementTabView.vue?vue&type=template&id=77282065&scoped=true&ts=true"
import script from "./TenantManagementTabView.vue?vue&type=script&lang=ts"
export * from "./TenantManagementTabView.vue?vue&type=script&lang=ts"

import "./TenantManagementTabView.vue?vue&type=style&index=0&id=77282065&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77282065"]])

export default __exports__